import { useState, useEffect } from "react";
import { 
  UtensilsCrossed, Salad, Drumstick, Beef, Fish, Pizza, 
  Sandwich, IceCream, GlassWater, ShoppingCart, Phone, 
  MapPin, Clock, ChefHat, Truck, Plus, Minus, X, Check,
  CreditCard, AlertTriangle, Loader2, Wallet
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Menu data - Prix livraison
const menuData = {
  salades: {
    name: "Salades",
    icon: Salad,
    color: "text-green-500",
    items: [
      { id: "sal1", name: "Salade niçoise", price: 3600 },
      { id: "sal2", name: "Salade crudités", price: 2200 },
      { id: "sal3", name: "Salade César", price: 4000 },
      { id: "sal4", name: "Salade Maxo", price: 4500, popular: true },
      { id: "sal5", name: "Salade Avocat crevettes", price: 4000 },
      { id: "sal6", name: "Salade au thon", price: 3600 }
    ]
  },
  entrees: {
    name: "Entrées",
    icon: ChefHat,
    color: "text-orange-500",
    items: [
      { id: "ent1", name: "Samossas au Poulet", price: 2200 },
      { id: "ent2", name: "Samossas à la viande", price: 2200 },
      { id: "ent3", name: "Neems Poulet ou Viande", price: 2200 }
    ]
  },
  volailles: {
    name: "Plats de Volaille",
    icon: Drumstick,
    color: "text-yellow-500",
    items: [
      { id: "vol1", name: "Sauce Poulet au Curry", price: 4900, description: "Poulet Chair ou Bicyclette" },
      { id: "vol2", name: "Choukouya Poulet Bicyclette", price: 5400, popular: true },
      { id: "vol3", name: "Choukouya Poulet Chair (Demi)", price: 4500 },
      { id: "vol4", name: "Poulet chair Frit/Grillé/BFW (Demi)", price: 4500 },
      { id: "vol5", name: "Poulet chair Frit/Grillé/BFW (Complet)", price: 8100 },
      { id: "vol6", name: "Poulet Bicyclette Frit/Braisé/Grillé", price: 5400 }
    ]
  },
  viandes: {
    name: "Plats de Viande Rouge",
    icon: Beef,
    color: "text-red-500",
    items: [
      { id: "via1", name: "Filet de Boeuf sauce champignons", price: 5400, description: "Sauce crème aux champignons" },
      { id: "via2", name: "Steaks Grillés", price: 4900 },
      { id: "via3", name: "Steak au poivre", price: 4900, popular: true },
      { id: "via4", name: "Choukouya Mouton", price: 4500 },
      { id: "via5", name: "Mouton frit/braisé/Grillé", price: 4500 },
      { id: "via6", name: "Langue de Boeuf Braisé/Grillé", price: 4500 },
      { id: "via7", name: "Agneau Frit/Braisé/Grillé", price: 4500 }
    ]
  },
  poissons: {
    name: "Plats de Poisson",
    icon: Fish,
    color: "text-blue-500",
    items: [
      { id: "poi1", name: "Poisson frit/Braisé/Grillé", price: 5400 },
      { id: "poi2", name: "Moyo Poisson", price: 5400, description: "Poisson au choix" }
    ]
  },
  divers: {
    name: "Plats Divers",
    icon: UtensilsCrossed,
    color: "text-purple-500",
    items: [
      { id: "div1", name: "Lapin frit/Braisé/Grillé (Portion)", price: 3600 },
      { id: "div2", name: "Aileron Frit/Braisé/Grillé", price: 4500 }
    ]
  },
  locaux: {
    name: "Plats locaux sur commande",
    icon: ChefHat,
    color: "text-amber-400",
    on_demand_category: true,
    items: [
      { id: "loc1", name: "Wagasi grillé (fromage peulh)", price: 3600, description: "Servi avec piment & oignon", on_demand: true },
      { id: "loc2", name: "Tchitchinga (brochettes pimentées de bœuf)", price: 4500, description: "Brochettes épicées à la béninoise", on_demand: true, popular: true },
      { id: "loc3", name: "Pintade braisée à la béninoise", price: 6800, description: "Pintade entière marinée, braisée au feu de bois", on_demand: true, popular: true },
      { id: "loc4", name: "Wo (pâte d'igname) + sauce arachide", price: 4900, description: "Pâte d'igname pilée, sauce arachide traditionnelle", on_demand: true },
      { id: "loc5", name: "Igname pilée + sauce graine", price: 4900, description: "Igname pilée à la main, sauce graine de palme", on_demand: true },
      { id: "loc6", name: "Watché complet (riz-haricots, poisson, sauce gboma)", price: 4500, description: "Plat complet de la tradition béninoise", on_demand: true },
      { id: "loc7", name: "Gboma Dessi (sauce épinards locaux)", price: 4500, description: "Sauce épinards GBOMA, viande ou poisson", on_demand: true },
      { id: "loc8", name: "Akpan local (yaourt traditionnel)", price: 1300, description: "Dessert traditionnel à base de maïs fermenté", on_demand: true }
    ]
  },
  sauces: {
    name: "Sauces Traditionnelles",
    icon: ChefHat,
    color: "text-amber-600",
    items: [
      { id: "sau1", name: "Sauce Légume GBOMA/TCHIAVO/AMANVIVÈ", price: 4500 },
      { id: "sau2", name: "Sauce Légume Mixte", price: 4900, description: "Au choix de légume" },
      { id: "sau3", name: "Sauce Vassa", price: 4900, description: "Poulet Chair ou Bicyclette", popular: true },
      { id: "sau4", name: "Sauce Assrokouin", price: 4500 },
      { id: "sau5", name: "Sauce Arachide (Fromage/Poisson)", price: 4500 },
      { id: "sau6", name: "Agneau en Sauce Arachide", price: 4500 },
      { id: "sau7", name: "Agneau en Sauce Tomate", price: 4500 },
      { id: "sau8", name: "Sauce Goussi (Sésame)", price: 4500 }
    ]
  },
  pates: {
    name: "Pâtes & Accompagnements",
    icon: UtensilsCrossed,
    color: "text-yellow-600",
    items: [
      { id: "pat1", name: "Spaghetti bolognaise", price: 3600 },
      { id: "pat2", name: "Tagliatelles crevettes", price: 4500 },
      { id: "pat3", name: "Spaghetti (Sauté au beurre/au gras)", price: 900 },
      { id: "pat4", name: "Pïron (Rouge/Blanc)", price: 900 },
      { id: "pat5", name: "Couscous (au gras/Blanc)", price: 900 },
      { id: "pat6", name: "Pâte Blanche (Pâte de Maïs)", price: 900 },
      { id: "pat7", name: "Pâte Noire (Télibo)", price: 900 },
      { id: "pat8", name: "Pâte Rouge (Amiwo)", price: 900 }
    ]
  },
  accompagnements: {
    name: "Accompagnements",
    icon: UtensilsCrossed,
    color: "text-lime-500",
    items: [
      { id: "acc1", name: "Riz blanc", price: 900 },
      { id: "acc2", name: "Riz Cantonais", price: 1300 },
      { id: "acc3", name: "Riz aux légumes", price: 1300 },
      { id: "acc4", name: "Pomme sautée", price: 1300 },
      { id: "acc5", name: "Frite surgelée", price: 900 },
      { id: "acc6", name: "Frite Nature", price: 1300 },
      { id: "acc7", name: "Atiékè", price: 900 },
      { id: "acc8", name: "Akassa", price: 400 },
      { id: "acc9", name: "Salade verte", price: 1300 }
    ]
  },
  burgers: {
    name: "Burgers",
    icon: Sandwich,
    color: "text-orange-600",
    items: [
      { id: "bur1", name: "MeetBurger", price: 2200, description: "Viande burger, oignons, tomate, cornichons, salade" },
      { id: "bur2", name: "CheeseBurger", price: 2700, description: "Viande burger, cheese, oignons, tomate, cornichons" },
      { id: "bur3", name: "Double Cheese Burger", price: 4500, description: "Double viande, double cheese", popular: true },
      { id: "bur4", name: "KingBurger", price: 3100, description: "Viande, cheese, oeuf, oignons, tomate, cornichons" },
      { id: "bur5", name: "Burger Maxo", price: 3600, description: "Poulet crispy, cheese, oeuf, oignons, tomate", popular: true }
    ]
  },
  sandwichs: {
    name: "Sandwichs & Shawarmas",
    icon: Sandwich,
    color: "text-amber-500",
    items: [
      { id: "san1", name: "Chawarma Viande", price: 1800 },
      { id: "san2", name: "Chawarma Poulet", price: 1800 },
      { id: "san3", name: "Sandwich au Poisson + Frite", price: 2700 },
      { id: "san4", name: "Sandwich Fajitas + Frite", price: 2700 },
      { id: "san5", name: "Sandwich Philadelphia + Frite", price: 2700 },
      { id: "san6", name: "Sandwich MAXO + Frite", price: 2700, popular: true }
    ]
  },
  pizzas: {
    name: "Pizzas",
    icon: Pizza,
    color: "text-red-600",
    items: [
      { id: "piz1", name: "Pizza Reine", price: 4500, description: "Sauce tomate, Jambon, Champignon, fromage" },
      { id: "piz2", name: "Pizza 4 saisons", price: 4500, description: "Jambon, artichaut, champignon, poivron" },
      { id: "piz3", name: "Pizza Margherita", price: 4000, description: "Sauce tomate, olive, origan, fromage" },
      { id: "piz4", name: "Pizza Maxo", price: 5400, description: "Chorizo, champignon, poulet, origan, olive", popular: true },
      { id: "piz5", name: "Pizza Végétarienne", price: 4500, description: "Oignon, champignon, maïs, poivron, olive" },
      { id: "piz6", name: "Pizza Bolognaise", price: 4500, description: "Sauce tomate, viande hachée, fromage" }
    ]
  },
  desserts: {
    name: "Desserts",
    icon: IceCream,
    color: "text-pink-500",
    items: [
      { id: "des1", name: "Crêpe Nature (1 pièce)", price: 600 },
      { id: "des2", name: "Crêpe au Nutella (1 pièce)", price: 1300 },
      { id: "des3", name: "Salade de Fruit", price: 900 },
      { id: "des4", name: "Ananas Pirogue", price: 900 },
      { id: "des5", name: "Assiette de Fruit", price: 1300 },
      { id: "des6", name: "Glace Chocolat/Fraise/Vanille (boule)", price: 900 },
      { id: "des7", name: "Coupe de glace (3 boules + chantilly)", price: 2200, popular: true }
    ]
  },
  boissons: {
    name: "Boissons",
    icon: GlassWater,
    color: "text-cyan-500",
    items: [
      { id: "boi1", name: "Majestic / World cola", price: 900 },
      { id: "boi2", name: "Jus d'orange", price: 900 },
      { id: "boi3", name: "Jus d'ananas", price: 900 },
      { id: "boi4", name: "Jus de pastèque", price: 900 },
      { id: "boi5", name: "Jus Mixte (Mélange au choix)", price: 1300 },
      { id: "boi6", name: "Béninoises 0,33 cl", price: 900 },
      { id: "boi7", name: "Sombreros 0,33 cl", price: 900 },
      { id: "boi8", name: "Guinness 0,33 cl", price: 1300 },
      { id: "boi9", name: "Chill 0,33 cl", price: 900 }
    ]
  }
};

const DeliveryPage = () => {
  // ── Menu dynamique : items chargés depuis l'API, fallback sur menuData en dur ──
  // La META des catégories (name, icon, color) reste dans le code car non éditable.
  const [dynamicItems, setDynamicItems] = useState(null); // null = pas encore chargé
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/delivery-menu`)
      .then(({ data }) => {
        if (!cancelled && data?.items_by_category) {
          setDynamicItems(data.items_by_category);
        }
      })
      .catch(() => {
        // En cas d'échec, on garde le menuData hardcoded comme fallback
      });
    return () => { cancelled = true; };
  }, []);

  // Construit le menu final = META catégories + items dynamiques (ou hardcoded fallback)
  const liveMenuData = (() => {
    const out = {};
    for (const [key, cat] of Object.entries(menuData)) {
      const dynItems = dynamicItems && dynamicItems[key];
      out[key] = {
        ...cat,
        items: dynItems
          ? dynItems.map((it) => ({
              id: it.id,
              name: it.name,
              price: it.price, // peut être null = "Sur devis"
              description: it.description,
              popular: it.popular,
              on_demand: it.on_demand,
            }))
          : cat.items,
      };
    }
    return out;
  })();

  const [cart, setCart] = useState([]);
  const [activeCategory, setActiveCategory] = useState("salades");
  const [showCart, setShowCart] = useState(false);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [orderForm, setOrderForm] = useState({
    name: "",
    phone: "",
    address: "",
    notes: "",
    zone: "cotonou", // cotonou or outside
    mode: "delivery", // "delivery" | "pickup" | "dine_in"
    scheduled_date: "", // YYYY-MM-DD (dine_in uniquement)
    scheduled_time: "", // HH:mm (dine_in uniquement)
  });
  const [submitting, setSubmitting] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [paymentConfig, setPaymentConfig] = useState(null);
  const [awaitingPayment, setAwaitingPayment] = useState(false);
  const [pendingOrderId, setPendingOrderId] = useState(null);
  
  // Wallet states
  const [walletBalance, setWalletBalance] = useState(0);
  const [useWallet, setUseWallet] = useState(false);
  const [walletLoading, setWalletLoading] = useState(false);

  // Fetch payment config on mount
  useEffect(() => {
    const fetchPaymentConfig = async () => {
      try {
        const response = await axios.get(`${API}/payment/config`);
        setPaymentConfig(response.data);
      } catch (error) {
        console.error("Error fetching payment config:", error);
      }
    };
    fetchPaymentConfig();
  }, []);

  // Fetch wallet balance when phone changes
  useEffect(() => {
    const fetchWalletBalance = async () => {
      if (orderForm.phone && orderForm.phone.length >= 8) {
        setWalletLoading(true);
        try {
          const response = await axios.get(`${API}/wallet/${orderForm.phone}`);
          setWalletBalance(response.data.balance || 0);
        } catch (error) {
          setWalletBalance(0);
        } finally {
          setWalletLoading(false);
        }
      } else {
        setWalletBalance(0);
        setUseWallet(false);
      }
    };
    
    const timeoutId = setTimeout(fetchWalletBalance, 500);
    return () => clearTimeout(timeoutId);
  }, [orderForm.phone]);

  // Load Kkiapay script
  useEffect(() => {
    if (!document.getElementById("kkiapay-script")) {
      const script = document.createElement("script");
      script.id = "kkiapay-script";
      script.src = "https://cdn.kkiapay.me/k.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  // Add item to cart
  const addToCart = (item) => {
    const existing = cart.find(c => c.id === item.id);
    if (existing) {
      setCart(cart.map(c => 
        c.id === item.id ? { ...c, quantity: c.quantity + 1 } : c
      ));
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }
    toast.success(`${item.name} ajouté au panier`);
  };

  // Remove item from cart
  const removeFromCart = (itemId) => {
    setCart(cart.filter(c => c.id !== itemId));
  };

  // Update quantity
  const updateQuantity = (itemId, delta) => {
    setCart(cart.map(c => {
      if (c.id === itemId) {
        const newQty = c.quantity + delta;
        return newQty > 0 ? { ...c, quantity: newQty } : c;
      }
      return c;
    }).filter(c => c.quantity > 0));
  };

  // Format price with thousands separator
  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR').format(price);
  };

  // Promo Vacances -25% (toggle Admin via /api/promo-vacances)
  const [promoActive, setPromoActive] = useState(true);
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/promo-vacances`)
      .then(({ data }) => {
        if (!cancelled && data && data.active === false) setPromoActive(false);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Calculate total
  const cartTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  // Détection : panier contient au moins un plat local "sur commande"
  // → impose une réservation J+1 minimum sur scheduled_date / scheduled_time
  const cartHasOnDemand = cart.some((c) => c.on_demand);
  // Pas de frais si retrait OU consommation sur place
  const deliveryFee = (orderForm.mode === "pickup" || orderForm.mode === "dine_in")
    ? 0
    : (orderForm.zone === "cotonou" ? 1000 : 0);
  // Réduction -25% appliquée si total ≥ 10 000 FCFA et promo active
  const discountEligible = promoActive && cartTotal >= 10000;
  const discountAmount = discountEligible ? Math.round(cartTotal * 0.25) : 0;
  const subtotalAfterDiscount = cartTotal - discountAmount;
  const totalWithDelivery = subtotalAfterDiscount + deliveryFee;

  // Validation 6h pour dine_in : la date+heure choisie doit être ≥ 6h dans le futur
  const dineInScheduledMs = (() => {
    if (orderForm.mode !== "dine_in") return null;
    if (!orderForm.scheduled_date || !orderForm.scheduled_time) return null;
    const dt = new Date(`${orderForm.scheduled_date}T${orderForm.scheduled_time}:00`);
    const ms = dt.getTime();
    return Number.isFinite(ms) ? ms : null;
  })();
  const sixHoursMs = 6 * 60 * 60 * 1000;
  const dineInTooSoon =
    orderForm.mode === "dine_in" &&
    dineInScheduledMs !== null &&
    dineInScheduledMs - Date.now() < sixHoursMs;
  const dineInMissingSchedule =
    orderForm.mode === "dine_in" &&
    (!orderForm.scheduled_date || !orderForm.scheduled_time);

  // Min datetime-local value = maintenant + 6h, formaté YYYY-MM-DDTHH:mm
  const minScheduledDate = (() => {
    const d = new Date(Date.now() + sixHoursMs);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  })();

  // Min date pour les plats locaux "sur commande" = J+1 (24h à l'avance)
  const minPreorderDate = (() => {
    const d = new Date(Date.now() + 24 * 60 * 60 * 1000);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  })();

  // Validation 24h pour les plats sur commande : la date+heure choisie doit être ≥ 24h dans le futur
  const twentyFourHoursMs = 24 * 60 * 60 * 1000;
  const preorderScheduledMs = (() => {
    if (!cartHasOnDemand) return null;
    if (!orderForm.scheduled_date || !orderForm.scheduled_time) return null;
    const dt = new Date(`${orderForm.scheduled_date}T${orderForm.scheduled_time}:00`);
    const ms = dt.getTime();
    return Number.isFinite(ms) ? ms : null;
  })();
  const preorderTooSoon =
    cartHasOnDemand &&
    preorderScheduledMs !== null &&
    preorderScheduledMs - Date.now() < twentyFourHoursMs;
  const preorderMissingSchedule =
    cartHasOnDemand && (!orderForm.scheduled_date || !orderForm.scheduled_time);
  
  // Calculate wallet usage
  const walletAmountToUse = useWallet ? Math.min(walletBalance, totalWithDelivery) : 0;
  const amountToPay = totalWithDelivery - walletAmountToUse;

  // Create order in backend
  const createOrder = async (paymentStatus = "pending", transactionId = null, walletAmount = 0) => {
    const isPickup = orderForm.mode === "pickup";
    const isDineIn = orderForm.mode === "dine_in";
    const orderData = {
      customer_name: orderForm.name,
      customer_phone: orderForm.phone,
      delivery_address: isPickup
        ? "Retrait sur place"
        : isDineIn
        ? "Consommation sur place au restaurant"
        : orderForm.address,
      delivery_zone: isPickup ? "pickup" : isDineIn ? "dine_in" : orderForm.zone,
      order_mode: orderForm.mode,
      scheduled_at: (isDineIn || cartHasOnDemand) && orderForm.scheduled_date && orderForm.scheduled_time
        ? `${orderForm.scheduled_date}T${orderForm.scheduled_time}:00`
        : null,
      is_preorder: cartHasOnDemand,
      notes: orderForm.notes,
      items: cart.map(item => ({
        name: item.name,
        price: item.price,
        quantity: item.quantity
      })),
      subtotal: cartTotal,
      discount_amount: discountAmount,
      promo_25_applied: discountEligible,
      delivery_fee: deliveryFee,
      total: totalWithDelivery,
      payment_status: paymentStatus,
      payment_transaction_id: transactionId,
      wallet_amount_used: walletAmount
    };

    const response = await axios.post(`${API}/delivery-orders`, orderData);
    return response.data;
  };

  // Handle order submission
  const handleSubmitOrder = async () => {
    // Adresse non requise en mode "Retrait" ou "Sur place"
    const addressRequired = orderForm.mode === "delivery";
    if (!orderForm.name || !orderForm.phone || (addressRequired && !orderForm.address)) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }

    // Validation 6h pour Consommation sur place
    if (orderForm.mode === "dine_in") {
      if (dineInMissingSchedule) {
        toast.error("Veuillez choisir une date et une heure de venue");
        return;
      }
      if (dineInTooSoon) {
        toast.error("Complet pour ce créneau. Veuillez réserver au moins 6 heures à l'avance.");
        return;
      }
    }

    // Validation 24h pour plats locaux sur commande
    if (cartHasOnDemand) {
      if (preorderMissingSchedule) {
        toast.error("Plats locaux : veuillez choisir une date et une heure de récupération (24h à l'avance minimum)");
        return;
      }
      if (preorderTooSoon) {
        toast.error("Plats locaux sur commande : réservation 24h à l'avance minimum.");
        return;
      }
    }

    // Pickup et Dine-in : paiement direct (gratuit hors repas), pas de zone
    if (orderForm.zone === "cotonou" || orderForm.mode === "pickup" || orderForm.mode === "dine_in") {
      // If wallet covers entire amount
      if (useWallet && amountToPay === 0) {
        await handleWalletOnlyPayment();
      } else {
        // Payment required via Kkiapay (possibly partial after wallet)
        initiatePayment();
      }
    } else {
      // Outside Cotonou: Submit for validation
      await submitForValidation();
    }
  };

  // Handle payment entirely from wallet
  const handleWalletOnlyPayment = async () => {
    setLoading(true);
    try {
      // Deduct from wallet
      await axios.post(`${API}/wallet/use`, {
        phone: orderForm.phone,
        amount: walletAmountToUse,
        description: `Commande livraison Espace Maxo`
      });

      // Create order with paid status
      await createOrder("paid", "wallet_payment", walletAmountToUse);

      setSuccessMessage(`Commande confirmée ! Paiement de ${formatPrice(walletAmountToUse)} FCFA effectué via votre porte-monnaie. Livraison sous 45-60 minutes.`);
      setOrderSuccess(true);
      setCart([]);
      setShowOrderModal(false);
      setUseWallet(false);
      setWalletBalance(prev => prev - walletAmountToUse);
    } catch (error) {
      console.error("Wallet payment error:", error);
      toast.error("Erreur lors du paiement. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  // Initiate Kkiapay payment for Cotonou orders
  const initiatePayment = () => {
    if (!paymentConfig || !window.openKkiapayWidget) {
      toast.error("Service de paiement non disponible. Veuillez réessayer.");
      return;
    }

    setAwaitingPayment(true);

    window.openKkiapayWidget({
      amount: amountToPay, // Amount after wallet deduction
      position: "center",
      callback: "",
      data: "",
      theme: "#FF6B00",
      key: paymentConfig.public_key,
      sandbox: paymentConfig.sandbox,
      phone: orderForm.phone.replace(/\s/g, ''),
      name: orderForm.name,
      description: `Commande Livraison Espace Maxo${walletAmountToUse > 0 ? ` (${formatPrice(walletAmountToUse)} FCFA via porte-monnaie)` : ''}`
    });

    // Listen for payment success
    window.addSuccessListener(async (response) => {
      console.log("Payment success:", response);
      toast.success("Paiement réussi!");
      
      try {
        // Deduct wallet amount if used
        if (useWallet && walletAmountToUse > 0) {
          await axios.post(`${API}/wallet/use`, {
            phone: orderForm.phone,
            amount: walletAmountToUse,
            description: `Commande livraison Espace Maxo (complément)`
          });
          setWalletBalance(prev => prev - walletAmountToUse);
        }
        
        // Create order with payment confirmed
        await createOrder("paid", response.transactionId, walletAmountToUse);
        setOrderSuccess(true);
        setSuccessMessage(`Votre commande est confirmée et en cours de préparation. ${walletAmountToUse > 0 ? `(${formatPrice(walletAmountToUse)} FCFA via porte-monnaie + ${formatPrice(amountToPay)} FCFA via mobile money) ` : ''}Livraison dans 30-45 minutes!`);
        setCart([]);
        setShowOrderForm(false);
        setUseWallet(false);
      } catch (error) {
        console.error("Error creating order:", error);
        toast.error("Erreur lors de l'enregistrement. Contactez-nous avec votre ID de paiement.");
      }
      
      setAwaitingPayment(false);
    });

    window.addFailedListener((response) => {
      console.log("Payment failed:", response);
      setAwaitingPayment(false);
      toast.error("Le paiement a échoué. Veuillez réessayer.");
    });

    window.addKkiapayCloseListener(() => {
      setAwaitingPayment(false);
    });
  };

  // Submit order for validation (outside Cotonou)
  const submitForValidation = async () => {
    setSubmitting(true);
    try {
      await createOrder("pending_validation", null);
      setOrderSuccess(true);
      setSuccessMessage("Votre commande a été soumise pour validation. Nous vous contacterons sous peu pour confirmer la disponibilité de livraison et les frais dans votre zone.");
      setCart([]);
      setShowOrderForm(false);
      toast.success("Commande soumise pour validation!");
    } catch (error) {
      console.error("Error submitting order:", error);
      toast.error("Erreur lors de l'envoi. Veuillez réessayer.");
    } finally {
      setSubmitting(false);
    }
  };

  const categories = Object.keys(liveMenuData);

  return (
    <div className="min-h-screen pt-20 bg-dark-bg" data-testid="delivery-page">
      {/* Hero */}
      <section className="py-12 px-4 bg-gradient-to-br from-food-orange/20 via-dark-bg to-food-gold/10">
        <div className="max-w-6xl mx-auto text-center">
          <Truck className="w-16 h-16 text-food-orange mx-auto mb-4" />
          <h1 className="font-orbitron font-black text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight mb-4">
            <span className="text-white">Notre carte</span>{" "}
            <span className="text-food-orange">de menus</span>
          </h1>
          <p className="text-gray-300 font-outfit text-lg max-w-2xl mx-auto mb-6">
            Savourez les délices d'Espace Maxo chez vous ou sur place ! Commandez en ligne et profitez d'une livraison rapide.
          </p>
          {promoActive && (
            <div className="bg-gradient-to-r from-amber-500/30 via-orange-500/20 to-rose-500/30 border border-amber-400/50 rounded-xl px-4 py-3 mb-6 max-w-2xl mx-auto" data-testid="delivery-promo-banner">
              <p className="text-amber-300 font-orbitron font-black text-base sm:text-lg uppercase">
                🎁 Promo Vacances · -25%
              </p>
              <p className="text-amber-100/90 text-sm mt-1">
                Sur toute commande dès <span className="font-bold">10 000 FCFA</span>. Réduction appliquée automatiquement au panier.
              </p>
            </div>
          )}
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Badge className="bg-food-gold/20 text-food-gold border-food-gold/30 px-4 py-2">
              <Clock className="w-4 h-4 mr-2" />
              Livraison 30-45 min
            </Badge>
            <Badge className="bg-green-500/20 text-green-400 border-green-500/30 px-4 py-2">
              <MapPin className="w-4 h-4 mr-2" />
              Cotonou: 1 000 FCFA
            </Badge>
            <Badge className="bg-neon-blue/20 text-neon-blue border-neon-blue/30 px-4 py-2">
              <CreditCard className="w-4 h-4 mr-2" />
              Paiement Mobile Money
            </Badge>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-8 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Categories Sidebar */}
            <div className="lg:w-64 flex-shrink-0">
              <div className="bg-dark-card rounded-xl p-4 sticky top-24">
                <h3 className="font-orbitron text-lg text-white mb-4">Catégories</h3>
                <div className="space-y-2">
                  {categories.map(catKey => {
                    const cat = liveMenuData[catKey];
                    const Icon = cat.icon;
                    return (
                      <button
                        key={catKey}
                        onClick={() => setActiveCategory(catKey)}
                        className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-left ${
                          activeCategory === catKey 
                            ? "bg-food-orange/20 text-food-orange" 
                            : "text-gray-400 hover:text-white hover:bg-white/5"
                        }`}
                      >
                        <Icon className={`w-5 h-5 ${cat.color}`} />
                        <span className="font-outfit text-sm">{cat.name}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="flex-1">
              <div className="mb-6">
                <h2 className="font-orbitron text-2xl text-white flex items-center gap-3">
                  {(() => {
                    const Icon = liveMenuData[activeCategory].icon;
                    return <Icon className={`w-7 h-7 ${liveMenuData[activeCategory].color}`} />;
                  })()}
                  {liveMenuData[activeCategory].name}
                </h2>
              </div>

              {/* Bandeau d'information "Sur commande" — affiché uniquement pour la catégorie locaux */}
              {liveMenuData[activeCategory].on_demand_category && (
                <div className="mb-5 rounded-xl border border-amber-500/40 bg-gradient-to-r from-amber-500/15 via-orange-500/10 to-rose-500/10 p-4 flex items-start gap-3" data-testid="locaux-info-banner">
                  <div className="shrink-0 w-10 h-10 rounded-full bg-amber-500/20 ring-2 ring-amber-500/40 flex items-center justify-center text-xl">
                    🍲
                  </div>
                  <div className="min-w-0">
                    <p className="font-orbitron text-amber-300 font-black uppercase text-sm tracking-wider">
                      Réservation 24h à l&apos;avance
                    </p>
                    <p className="text-amber-100/90 text-xs sm:text-sm mt-1 leading-relaxed">
                      Nos plats locaux sont préparés à la commande, à la main, dans le respect des traditions béninoises.
                      Merci de réserver <strong className="text-white">au moins 24 heures à l&apos;avance</strong> en
                      précisant votre date &amp; heure de récupération au moment du paiement. Livraison, retrait sur place
                      ou consommation au restaurant — au choix.
                    </p>
                  </div>
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {liveMenuData[activeCategory].items.map(item => {
                  const noPrice = item.price === null || item.price === undefined;
                  const quoteUrl = `https://wa.me/2290141470000?text=${encodeURIComponent(`Bonjour Espace Maxo, je souhaite obtenir un devis pour : ${item.name}. Merci.`)}`;
                  return (
                  <Card 
                    key={item.id} 
                    className={`bg-dark-card transition-colors ${item.on_demand ? "border-amber-500/30 hover:border-amber-400/60" : "border-white/10 hover:border-food-orange/30"}`}
                    data-testid={`menu-card-${item.id}`}
                  >
                    <CardContent className="p-4">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 flex-wrap">
                            <h3 className="font-outfit font-semibold text-white">{item.name}</h3>
                            {item.popular && (
                              <Badge className="bg-food-gold/20 text-food-gold text-xs">Populaire</Badge>
                            )}
                            {item.on_demand && (
                              <Badge
                                className="bg-amber-500/20 text-amber-300 border border-amber-500/40 text-[10px] uppercase tracking-wider font-bold"
                                data-testid={`on-demand-badge-${item.id}`}
                              >
                                🍲 Sur commande
                              </Badge>
                            )}
                          </div>
                          {item.description && (
                            <p className="text-gray-500 text-sm mt-1">{item.description}</p>
                          )}
                          {noPrice ? (
                            <p className="text-amber-300 font-rajdhani font-bold text-lg mt-2 italic" data-testid={`price-quote-${item.id}`}>
                              Sur devis · contactez-nous
                            </p>
                          ) : (
                            <p className={`font-rajdhani font-bold text-xl mt-2 ${item.on_demand ? "text-amber-300" : "text-food-orange"}`}>
                              {item.price.toLocaleString()} FCFA
                            </p>
                          )}
                          {item.on_demand && !noPrice && (
                            <p className="text-[10px] text-amber-200/70 mt-0.5 italic">
                              Préparation 24h · choisir date &amp; heure au paiement
                            </p>
                          )}
                        </div>
                        {noPrice ? (
                          <a
                            href={quoteUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1 bg-amber-500 hover:bg-amber-400 text-slate-900 text-xs font-bold px-3 py-2 rounded-md whitespace-nowrap shadow"
                            data-testid={`quote-btn-${item.id}`}
                            title="Demander un devis sur WhatsApp"
                          >
                            <Phone className="w-3.5 h-3.5" />
                            Devis
                          </a>
                        ) : (
                          <Button
                            onClick={() => addToCart(item)}
                            size="sm"
                            className={item.on_demand ? "bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold" : "bg-food-orange hover:bg-food-orange/80 text-white"}
                            data-testid={`add-to-cart-${item.id}`}
                          >
                            <Plus className="w-4 h-4" />
                          </Button>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Floating Cart Button - Like Combos Page */}
      {cart.length > 0 && !showCart && !showOrderForm && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50">
          <Button
            onClick={() => setShowCart(true)}
            className="bg-yellow-400 hover:bg-yellow-300 text-black font-rajdhani font-bold text-lg px-8 py-7 rounded-full shadow-[0_0_40px_rgba(255,255,0,0.7)] hover:shadow-[0_0_50px_rgba(255,255,0,0.9)] transition-all border-2 border-black"
            data-testid="floating-cart-btn"
          >
            <ShoppingCart className="w-6 h-6 mr-3" />
            <span className="font-bold">{cart.reduce((sum, item) => sum + item.quantity, 0)} article{cart.reduce((sum, item) => sum + item.quantity, 0) > 1 ? 's' : ''}</span>
            <span className="mx-2">•</span>
            <span className="font-bold">{formatPrice(cartTotal)} FCFA</span>
          </Button>
        </div>
      )}

      {/* Cart Dialog */}
      <Dialog open={showCart} onOpenChange={setShowCart}>
        <DialogContent className="bg-dark-card border-white/20 text-white max-w-md max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-orbitron text-xl flex items-center gap-2">
              <ShoppingCart className="w-5 h-5 text-food-orange" />
              Votre Panier
            </DialogTitle>
          </DialogHeader>

          {cart.length === 0 ? (
            <p className="text-gray-400 text-center py-8">Votre panier est vide</p>
          ) : (
            <>
              {cartHasOnDemand && (
                <div className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-2.5 text-xs text-amber-200 flex items-start gap-2 mb-2" data-testid="cart-on-demand-notice">
                  <span className="text-base leading-none">🍲</span>
                  <span>
                    Votre panier contient des <strong>plats locaux sur commande</strong>. Une date &amp; heure
                    de récupération (24h à l&apos;avance min.) sera demandée au paiement.
                  </span>
                </div>
              )}
              <div className="space-y-3 max-h-60 overflow-y-auto">
                {cart.map(item => (
                  <div key={item.id} className="flex items-center justify-between bg-white/5 rounded-lg p-3">
                    <div className="flex-1">
                      <p className="font-outfit text-sm text-white">{item.name}</p>
                      <p className="text-food-orange text-sm">{item.price.toLocaleString()} FCFA</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => updateQuantity(item.id, -1)}
                        className="p-1 hover:bg-white/10 rounded"
                      >
                        <Minus className="w-4 h-4" />
                      </button>
                      <span className="w-8 text-center">{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item.id, 1)}
                        className="p-1 hover:bg-white/10 rounded"
                      >
                        <Plus className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => removeFromCart(item.id)}
                        className="p-1 hover:bg-red-500/20 rounded text-red-400"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="border-t border-white/10 pt-4 space-y-2">
                <div className="flex justify-between text-gray-400">
                  <span>Sous-total</span>
                  <span>{cartTotal.toLocaleString()} FCFA</span>
                </div>
                {discountEligible && (
                  <div className="flex justify-between text-emerald-400 font-bold" data-testid="delivery-promo-discount">
                    <span>🎁 Promo Vacances -25%</span>
                    <span>-{discountAmount.toLocaleString()} FCFA</span>
                  </div>
                )}
                {promoActive && !discountEligible && cartTotal > 0 && (
                  <p className="text-[11px] text-amber-300 italic" data-testid="delivery-promo-hint">
                    Ajoutez encore {(10000 - cartTotal).toLocaleString()} FCFA pour bénéficier de la promo -25%
                  </p>
                )}
                <div className="flex justify-between text-gray-400">
                  <span>
                    {orderForm.mode === "pickup"
                      ? "Retrait sur place"
                      : orderForm.mode === "dine_in"
                      ? "Consommation sur place"
                      : "Frais de livraison (Cotonou)"}
                  </span>
                  <span>
                    {orderForm.mode === "pickup" || orderForm.mode === "dine_in"
                      ? "Gratuit"
                      : "1 000 FCFA"}
                  </span>
                </div>
                {orderForm.mode === "delivery" && (
                <div className="text-xs text-yellow-400">
                  * Hors Cotonou: frais à confirmer
                </div>
                )}
                <div className="flex justify-between text-white font-bold border-t border-white/10 pt-2" data-testid="delivery-total-line">
                  <span>Total</span>
                  <span>{totalWithDelivery.toLocaleString()} FCFA</span>
                </div>
              </div>

              <Button
                onClick={() => {
                  setShowCart(false);
                  setShowOrderForm(true);
                }}
                className="w-full bg-food-orange hover:bg-food-orange/80 text-white font-rajdhani font-bold uppercase py-6"
              >
                Commander maintenant
              </Button>
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* Order Form Dialog */}
      <Dialog open={showOrderForm} onOpenChange={setShowOrderForm}>
        <DialogContent className="bg-dark-card border-white/20 text-white max-w-md max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-orbitron text-xl flex items-center gap-2">
              <Truck className="w-5 h-5 text-food-orange" />
              Informations de livraison
            </DialogTitle>
          </DialogHeader>

          {orderSuccess ? (
            <div className="text-center py-8">
              <Check className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="font-orbitron text-xl text-white mb-2">
                {orderForm.zone === "cotonou" ? "Commande confirmée!" : "Commande soumise!"}
              </h3>
              <p className="text-gray-400 mb-4">{successMessage}</p>
              <Button
                onClick={() => {
                  setShowOrderForm(false);
                  setOrderSuccess(false);
                  setSuccessMessage("");
                }}
                className="bg-food-orange hover:bg-food-orange/80"
              >
                Fermer
              </Button>
            </div>
          ) : (
            <>
              <div className="space-y-4">
                {/* Mode Selection : Livraison, Retrait sur place ou Consommation sur place */}
                <div className="space-y-3">
                  <Label className="text-gray-300 font-semibold">Mode de récupération *</Label>
                  <RadioGroup
                    value={orderForm.mode}
                    onValueChange={(value) => setOrderForm({ ...orderForm, mode: value })}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-3"
                    data-testid="order-mode-radio"
                  >
                    <div className={`flex items-center space-x-3 p-3 rounded-lg border ${
                      orderForm.mode === "delivery"
                        ? "border-orange-500 bg-orange-500/10"
                        : "border-white/20"
                    }`}>
                      <RadioGroupItem value="delivery" id="mode-delivery" />
                      <Label htmlFor="mode-delivery" className="flex-1 cursor-pointer">
                        <span className="text-white font-semibold">🚚 Livraison à domicile</span>
                        <span className="block text-xs text-orange-300">Frais selon zone</span>
                      </Label>
                    </div>
                    <div className={`flex items-center space-x-3 p-3 rounded-lg border ${
                      orderForm.mode === "pickup"
                        ? "border-emerald-500 bg-emerald-500/10"
                        : "border-white/20"
                    }`}>
                      <RadioGroupItem value="pickup" id="mode-pickup" />
                      <Label htmlFor="mode-pickup" className="flex-1 cursor-pointer">
                        <span className="text-white font-semibold">🏠 Retrait sur place</span>
                        <span className="block text-xs text-emerald-300">Aucun frais · à venir chercher</span>
                      </Label>
                    </div>
                    <div className={`flex items-center space-x-3 p-3 rounded-lg border ${
                      orderForm.mode === "dine_in"
                        ? "border-sky-500 bg-sky-500/10"
                        : "border-white/20"
                    }`}>
                      <RadioGroupItem value="dine_in" id="mode-dine-in" />
                      <Label htmlFor="mode-dine-in" className="flex-1 cursor-pointer">
                        <span className="text-white font-semibold">🍽️ Consommation sur place</span>
                        <span className="block text-xs text-sky-300">Au restaurant · sur réservation</span>
                      </Label>
                    </div>
                  </RadioGroup>
                </div>

                {/* Sélecteur Date + Heure — uniquement pour Consommation sur place (dine_in) */}
                {orderForm.mode === "dine_in" && (
                  <div className="space-y-3 p-3 rounded-lg border border-sky-500/40 bg-sky-500/5" data-testid="dine-in-scheduler">
                    <Label className="text-sky-200 font-semibold flex items-center gap-1">
                      <Clock className="w-4 h-4" /> Date et heure de venue *
                    </Label>
                    <div className="grid grid-cols-2 gap-2">
                      <Input
                        type="date"
                        value={orderForm.scheduled_date}
                        min={minScheduledDate}
                        onChange={(e) => setOrderForm({ ...orderForm, scheduled_date: e.target.value })}
                        className="bg-dark-card border-white/20 text-white"
                        data-testid="dine-in-date"
                      />
                      <Input
                        type="time"
                        value={orderForm.scheduled_time}
                        onChange={(e) => setOrderForm({ ...orderForm, scheduled_time: e.target.value })}
                        className="bg-dark-card border-white/20 text-white"
                        data-testid="dine-in-time"
                      />
                    </div>
                    {dineInTooSoon && (
                      <div className="flex items-center gap-2 p-2 rounded bg-red-500/15 border border-red-500/40 text-red-200 text-xs font-semibold" data-testid="dine-in-full-msg">
                        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
                        Complet pour ce créneau. Veuillez réserver au moins 6 heures à l'avance.
                      </div>
                    )}
                    {!dineInTooSoon && !dineInMissingSchedule && (
                      <p className="text-[11px] text-emerald-300">
                        ✓ Créneau valide. Votre table sera réservée pour cette heure.
                      </p>
                    )}
                    {dineInMissingSchedule && (
                      <p className="text-[11px] text-sky-300/80">
                        Choisissez une date et une heure (minimum 6h à l'avance).
                      </p>
                    )}
                  </div>
                )}

                {/* Sélecteur Date + Heure — Plats locaux sur commande (24h à l'avance) */}
                {cartHasOnDemand && orderForm.mode !== "dine_in" && (
                  <div className="space-y-3 p-3 rounded-lg border border-amber-500/40 bg-amber-500/5" data-testid="preorder-scheduler">
                    <Label className="text-amber-200 font-semibold flex items-center gap-1">
                      🍲 Date et heure de récupération de vos plats locaux *
                    </Label>
                    <p className="text-[11px] text-amber-100/70">
                      Vos plats sont préparés à la commande. Choisissez un créneau <strong>au moins 24h à l&apos;avance</strong>.
                    </p>
                    <div className="grid grid-cols-2 gap-2">
                      <Input
                        type="date"
                        value={orderForm.scheduled_date}
                        min={minPreorderDate}
                        onChange={(e) => setOrderForm({ ...orderForm, scheduled_date: e.target.value })}
                        className="bg-dark-card border-amber-500/40 text-white"
                        data-testid="preorder-date"
                      />
                      <Input
                        type="time"
                        value={orderForm.scheduled_time}
                        onChange={(e) => setOrderForm({ ...orderForm, scheduled_time: e.target.value })}
                        className="bg-dark-card border-amber-500/40 text-white"
                        data-testid="preorder-time"
                      />
                    </div>
                    {preorderTooSoon && (
                      <div className="flex items-center gap-2 p-2 rounded bg-red-500/15 border border-red-500/40 text-red-200 text-xs font-semibold" data-testid="preorder-too-soon-msg">
                        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
                        Réservation 24h à l&apos;avance minimum. Choisissez un créneau plus tardif.
                      </div>
                    )}
                    {!preorderTooSoon && !preorderMissingSchedule && (
                      <p className="text-[11px] text-emerald-300">
                        ✓ Créneau validé. Vos plats seront prêts à cette heure.
                      </p>
                    )}
                    {preorderMissingSchedule && (
                      <p className="text-[11px] text-amber-300/80">
                        Choisissez une date et une heure (minimum 24h à l&apos;avance).
                      </p>
                    )}
                  </div>
                )}

                {/* Zone Selection — uniquement pour Livraison */}
                {orderForm.mode === "delivery" && (
                <div className="space-y-3">
                  <Label className="text-gray-300 font-semibold">Zone de livraison *</Label>
                  <RadioGroup
                    value={orderForm.zone}
                    onValueChange={(value) => setOrderForm({ ...orderForm, zone: value })}
                    className="flex flex-col gap-3"
                  >
                    <div className={`flex items-center space-x-3 p-3 rounded-lg border ${
                      orderForm.zone === "cotonou" 
                        ? "border-green-500 bg-green-500/10" 
                        : "border-white/20"
                    }`}>
                      <RadioGroupItem value="cotonou" id="cotonou" />
                      <Label htmlFor="cotonou" className="flex-1 cursor-pointer">
                        <span className="text-white font-semibold">Cotonou</span>
                        <span className="block text-sm text-green-400">Frais: 1 000 FCFA - Paiement immédiat</span>
                      </Label>
                    </div>
                    <div className={`flex items-center space-x-3 p-3 rounded-lg border ${
                      orderForm.zone === "outside" 
                        ? "border-yellow-500 bg-yellow-500/10" 
                        : "border-white/20"
                    }`}>
                      <RadioGroupItem value="outside" id="outside" />
                      <Label htmlFor="outside" className="flex-1 cursor-pointer">
                        <span className="text-white font-semibold">Hors Cotonou</span>
                        <span className="block text-sm text-yellow-400">Commande à valider - Nous vous contacterons</span>
                      </Label>
                    </div>
                  </RadioGroup>
                </div>
                )}

                <div>
                  <Label htmlFor="name" className="text-gray-300">Nom complet *</Label>
                  <Input
                    id="name"
                    value={orderForm.name}
                    onChange={(e) => setOrderForm({ ...orderForm, name: e.target.value })}
                    className="bg-surface-highlight border-white/20 text-white"
                    placeholder="Votre nom"
                  />
                </div>
                <div>
                  <Label htmlFor="phone" className="text-gray-300">Téléphone *</Label>
                  <Input
                    id="phone"
                    value={orderForm.phone}
                    onChange={(e) => setOrderForm({ ...orderForm, phone: e.target.value })}
                    className="bg-surface-highlight border-white/20 text-white"
                    placeholder="97 XX XX XX"
                  />
                </div>
                {orderForm.mode === "delivery" && (
                <div>
                  <Label htmlFor="address" className="text-gray-300">Adresse de livraison *</Label>
                  <Textarea
                    id="address"
                    value={orderForm.address}
                    onChange={(e) => setOrderForm({ ...orderForm, address: e.target.value })}
                    className="bg-surface-highlight border-white/20 text-white"
                    placeholder="Quartier, rue, repère..."
                    rows={3}
                  />
                </div>
                )}
                <div>
                  <Label htmlFor="notes" className="text-gray-300">Instructions (optionnel)</Label>
                  <Input
                    id="notes"
                    value={orderForm.notes}
                    onChange={(e) => setOrderForm({ ...orderForm, notes: e.target.value })}
                    className="bg-surface-highlight border-white/20 text-white"
                    placeholder="Ex: Sans oignons..."
                  />
                </div>
              </div>

              {/* Order Summary */}
              <div className={`rounded-lg p-4 mt-4 ${
                orderForm.zone === "cotonou" 
                  ? "bg-green-500/10 border border-green-500/30" 
                  : "bg-yellow-500/10 border border-yellow-500/30"
              }`}>
                {orderForm.zone === "cotonou" ? (
                  <>
                    <div className="flex justify-between text-gray-300 text-sm">
                      <span>Sous-total</span>
                      <span>{cartTotal.toLocaleString()} FCFA</span>
                    </div>
                    {discountEligible && (
                      <div className="flex justify-between text-emerald-400 text-sm font-bold">
                        <span>🎁 Promo -25%</span>
                        <span>-{discountAmount.toLocaleString()} FCFA</span>
                      </div>
                    )}
                    <div className="flex justify-between text-gray-300 text-sm">
                      <span>
                        {orderForm.mode === "pickup"
                          ? "Retrait sur place"
                          : orderForm.mode === "dine_in"
                          ? "Consommation sur place"
                          : "Livraison Cotonou"}
                      </span>
                      <span>
                        {orderForm.mode === "pickup" || orderForm.mode === "dine_in"
                          ? "Gratuit"
                          : "1 000 FCFA"}
                      </span>
                    </div>
                    <div className="flex justify-between text-white text-base font-bold border-t border-white/10 pt-2 mt-1">
                      <span>Total</span>
                      <span>{totalWithDelivery.toLocaleString()} FCFA</span>
                    </div>
                    
                    {/* Wallet Option */}
                    {walletBalance > 0 ? (
                      <div className="mt-3 p-3 rounded-lg bg-neon-blue/10 border border-neon-blue/30">
                        <label className="flex items-start gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={useWallet}
                            onChange={(e) => setUseWallet(e.target.checked)}
                            className="w-5 h-5 mt-0.5 rounded border-white/20 bg-surface-highlight text-neon-blue focus:ring-neon-blue"
                          />
                          <div className="flex-1">
                            <span className="font-outfit text-white font-semibold flex items-center gap-2">
                              <Wallet className="w-4 h-4 text-neon-blue" />
                              Utiliser mon porte-monnaie
                              <span className="text-neon-blue text-sm">({walletBalance.toLocaleString()} FCFA disponible)</span>
                            </span>
                            {useWallet && walletAmountToUse > 0 && (
                              <p className="text-sm text-neon-blue mt-1">
                                -{walletAmountToUse.toLocaleString()} FCFA sera déduit
                              </p>
                            )}
                          </div>
                        </label>
                      </div>
                    ) : orderForm.phone && orderForm.phone.length >= 8 ? (
                      <div className="mt-3 p-3 rounded-lg bg-yellow-500/10 border border-yellow-500/30">
                        <div className="flex items-start gap-3">
                          <Wallet className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" />
                          <div className="flex-1">
                            <p className="font-outfit text-yellow-400 font-semibold">
                              Porte-monnaie non disponible
                            </p>
                            <p className="text-sm text-gray-400 mt-1">
                              Votre porte-monnaie est vide. Rechargez-le pour vos prochaines commandes.
                            </p>
                            <a 
                              href="/provision" 
                              className="inline-flex items-center gap-1 text-neon-blue text-sm mt-2 hover:underline"
                            >
                              Recharger mon porte-monnaie →
                            </a>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    
                    <div className="flex justify-between text-green-400 font-bold text-lg mt-2 pt-2 border-t border-green-500/30">
                      <span>{useWallet && amountToPay === 0 ? "Total (couvert par porte-monnaie)" : "Total à payer"}</span>
                      <span>{amountToPay.toLocaleString()} FCFA</span>
                    </div>
                    <div className="flex items-center gap-2 mt-2 text-sm text-green-300">
                      <CreditCard className="w-4 h-4" />
                      <span>
                        {useWallet && amountToPay === 0 
                          ? "Paiement 100% via porte-monnaie" 
                          : "Paiement par Mobile Money (MTN, Moov, Celtiis)"}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex items-start gap-2 text-yellow-400">
                      <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                      <div>
                        <p className="font-semibold">Commande hors Cotonou</p>
                        <p className="text-sm text-yellow-300">
                          Votre commande sera soumise pour validation. Nous vous contacterons pour confirmer 
                          la disponibilité de livraison et les frais dans votre zone.
                        </p>
                      </div>
                    </div>
                    <div className="mt-3 text-gray-300">
                      <span>Sous-total: </span>
                      <span className="font-bold">{cartTotal.toLocaleString()} FCFA</span>
                      <span className="text-yellow-400 text-sm ml-2">(+ frais à confirmer)</span>
                    </div>
                  </>
                )}
              </div>

              <DialogFooter className="mt-4 flex-col sm:flex-row gap-2">
                <Button
                  variant="outline"
                  onClick={() => setShowOrderForm(false)}
                  className="border-white/20 text-gray-300"
                  disabled={submitting || awaitingPayment}
                >
                  Annuler
                </Button>
                <Button
                  onClick={handleSubmitOrder}
                  disabled={
                    submitting ||
                    awaitingPayment ||
                    !orderForm.name ||
                    !orderForm.phone ||
                    (orderForm.mode === "delivery" && !orderForm.address) ||
                    (orderForm.mode === "dine_in" && (dineInMissingSchedule || dineInTooSoon)) ||
                    (cartHasOnDemand && (preorderMissingSchedule || preorderTooSoon))
                  }
                  className={`font-rajdhani font-bold flex-1 ${
                    orderForm.zone === "cotonou"
                      ? "bg-green-600 hover:bg-green-700"
                      : "bg-yellow-600 hover:bg-yellow-700"
                  }`}
                  data-testid="delivery-submit-btn"
                >
                  {submitting || awaitingPayment ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin mr-2" />
                      {awaitingPayment ? "Paiement en cours..." : "Envoi..."}
                    </>
                  ) : orderForm.zone === "cotonou" ? (
                    <>
                      <CreditCard className="w-4 h-4 mr-2" />
                      Payer {totalWithDelivery.toLocaleString()} FCFA
                    </>
                  ) : (
                    <>
                      <Check className="w-4 h-4 mr-2" />
                      Soumettre pour validation
                    </>
                  )}
                </Button>
              </DialogFooter>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DeliveryPage;
